import HelpIcon from '@mui/icons-material/Help';
import classes from "./integrationStyles.module.scss"
import { cloneElement } from 'react';

const JoyrideContent = ({content, title, icon}) =>{
    return(<>
        {/* <div>
            <h4><span style={{marginRight:"0.5rem"}}></span>{title}</h4>
            {icon||<HelpIcon/>}{content}
        </div> */}
        <div className={`${classes["desc-wrapper"]} flex-column d-flex`}>
            <h5 className={classes["wiz-title"]}>{title}</h5>
            <ul className={`${classes["pricing-table-ul"]} ${classes["profile"]}`} style={{textAlign:"left"}}>
                <li>
                {icon && cloneElement(icon,  { className: icon.props.className + " "+classes["fa"]+" "})}
                {!icon && <HelpIcon className={classes["fa"]}/>}
                {content}</li>
            </ul>
            <div className="mt-auto w-100"></div>
        </div>
    </>)
}

export default JoyrideContent;